import { IGame, CATEGORY_VIEWS } from 'js/hooks/games/types';
import { TJackpots } from 'js/components/common/Jackpot/types';

export const getCategoryLayoutWithGames = (games: string[], itemPerLayout = 0) => {
    const result: string[][] = [];

    if (!itemPerLayout) {
        return result;
    }

    for (let i = 0; i < games.length; i += itemPerLayout) {
        result.push(games.slice(i, i + itemPerLayout));
    }

    return result;
};

export const filterAndSortGames = ({
    categoryGames = [], allGames, filterSortBy, filterProviders, categoryView,
    filterLabels, filterCategory, categoryName, filterCustomFields, jackpots
}: {
    jackpots: TJackpots;
    filterSortBy: string;
    categoryName: string;
    filterLabels: string;
    categoryView?: string;
    filterCategory: string;
    filterProviders: string;
    categoryGames?: string[];
    allGames: { [key: string]: IGame };
    filterCustomFields: { [key: string]: string };
}): string[] => {
    let result: string[] = [...categoryGames];
    const filterCategoryArr = filterCategory && filterCategory.split(',') || [];
    const filterProvidersArr = filterProviders && filterProviders.split(',') || [];
    const filterLabelsArr = filterLabels && filterLabels.split(',') || [];
    const isJackpotsPresent = Boolean(Object.keys(jackpots).length);

    if (categoryView === CATEGORY_VIEWS.top) {
        return result;
    }

    if (filterCategoryArr.length && !filterCategoryArr.includes(categoryName)) {
        return [];
    }

    if (categoryView === CATEGORY_VIEWS.webcontent &&
        !filterLabelsArr.length &&
        !filterProvidersArr.length &&
        !Object.keys(filterCustomFields).length
    ) {
        return ['webcontent'];
    }

    if (filterLabelsArr.length || filterProvidersArr.length || Object.keys(filterCustomFields).length) {
        result = result.filter((game) => {
            const isProviderExist = filterProvidersArr.length ? filterProvidersArr.includes(allGames[game].gameProvider) : true;

            const isLabelExist = filterLabelsArr.length ?
                allGames[game].gameLabels.some((label) => filterLabelsArr.includes(label.name) && label.isVisible) : true;

            const isCustomFieldsExist = Object.keys(filterCustomFields).length ?
                Object.keys(filterCustomFields).every((field) => {
                    const filterCustomFieldsArr = filterCustomFields[field] && filterCustomFields[field].split(',') || [];

                    return filterCustomFieldsArr.length ? allGames[game].gameCustomFieldsData.some((customField) =>
                        customField.name === field && customField.tpe === 'text' && filterCustomFieldsArr.includes(customField.value)) : true;
                }) : true;

            return isProviderExist && isLabelExist && isCustomFieldsExist;
        });
    }

    if (filterSortBy !== 'default') {
        result.sort((a, b) => {
            if (filterSortBy === 'a-z') {
                return allGames[a].name.localeCompare(allGames[b].name);
            }

            if (filterSortBy === 'z-a') {
                return allGames[b].name.localeCompare(allGames[a].name);
            }

            if (filterSortBy === 'jackpot' && isJackpotsPresent) {
                const jackpotA = jackpots[allGames[a].jackpotCode]?.amount || 0;
                const jackpotB = jackpots[allGames[b].jackpotCode]?.amount || 0;

                return jackpotB - jackpotA;
            }

            return 0;
        });
    }

    return result;
};
